import './style.css'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
//import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { World } from "./World";
import { Assets } from './Assets';
import { LoadingManager, RepeatWrapping, TextureLoader } from 'three';

const canvas = document.querySelector('canvas.webgl')
const nextButton = document.querySelector('.button.next')
const previousButton = document.querySelector('.button.previous')
const loaderUI = document.querySelector('.loader')
loaderUI.innerHTML = "Loading Textures"

nextButton.style.display = "none"
previousButton.style.display = "none"

const assets = new Assets();
const loadingManager = new LoadingManager;

let world, model
let mousePos = { x: 0, y: 0, px: 0, py: 0, cx: 0, cy: 0 }
let winWidth = 0
let winHeight = 0

// total size hardcoded !!!! watch out glb doesn't give a total size
const totalSize = 7852460
const modelPath = 'night.glb'

window.addEventListener('load', ()=>{ initLoading() })


function initLoading() {

    loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
        //console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
    };

    loadingManager.onLoad = () => {
        // console.log('Loading complete!');
        loaderUI.style.display = "none"
        nextButton.style.display = "block"
        previousButton.style.display = "block"
        setup()
    };
    /*
    loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
        //loaderUI.innerHTML = "Loading " + url;
        //console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
    };
    */

    loadingManager.onError = (url) => {
        console.log('There was an error loading ' + url);
    };

    loadAssets();
}

function loadAssets() {

    const textureLoader = new TextureLoader(loadingManager);

    textureLoader.load(`./textureC.jpg`, texture => {
        texture.wrapS = texture.wrapT = RepeatWrapping;
        assets.setTexture({ key: `hatchC`, texture });
    });
    textureLoader.load('./noise.jpg', texture => {
        texture.wrapS = texture.wrapT = RepeatWrapping;
        assets.setTexture({ key: 'noise', texture });
    });

    const loaderModel = new GLTFLoader(loadingManager)
    //const dracoLoader = new DRACOLoader()
    //dracoLoader.setDecoderPath( './draco/' )
    //loaderModel.setDRACOLoader( dracoLoader )    

    loaderModel.load(modelPath, (gltf) => {
        assets.model = gltf        
    },

    ( xhr ) => {
        loaderUI.innerHTML = "Loading Model <br/>" + Math.round( xhr.loaded / totalSize * 100 ) + '%';
        //console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
    },
    // called when loading has errors
    ( error ) => {

        console.log( 'An error happened', error );

    });
}

function setup() {
    world = new World({ canvas, assets })
    window.addEventListener('resize', onWindowResize)
    window.addEventListener('keydown', (event) => handleKeyDown(event));
    document.addEventListener("mousemove", handleMouseMove, false)
    nextButton.addEventListener('click', nextStep);
    previousButton.addEventListener('click', previousStep);
    onWindowResize()
    draw()
}

function onWindowResize() {
    winHeight = window.innerHeight
    winWidth = window.innerWidth
    if (world) world.resize(winWidth, winHeight)
}
  
function draw() {
    if (world) {
        world.render()
    }
    window.requestAnimationFrame(draw)
}

function handleMouseMove(e) {
    mousePos.x = e.clientX;
    mousePos.y = e.clientY;
    mousePos.px = mousePos.x / winWidth * 2 - 1
    mousePos.py = mousePos.y / winHeight * 2 - 1
    mousePos.cx = mousePos.x - winWidth / 2
    mousePos.cy = mousePos.y - winHeight / 2
    if (world) world.mouseMove(mousePos)
}

function handleKeyDown(event) {

    switch (event.keyCode) {
        case 37:
            previousStep()
            break;
        case 39:
            nextStep()
            break;
    }
}

function nextStep() {
    if (world) world.nextStep()
}

function previousStep() {
    if (world) world.previousStep()
}
